
const getModifyRight = async (userModulesData, key) => {
	let modifyRightResult = false

	if (userModulesData !== null) {
		userModulesData.map(module => {
			if (module.path === key) {
				if (module.rights.modifiable || module.rights.administrable) {
					modifyRightResult = true
				}
			}
		})
	}

	return modifyRightResult
}

const getAdministrableRight = async (userModulesData, key) => {
	let administrableRightResult = false

	if (userModulesData !== null) {
		userModulesData.map(module => {
			if (module.path === key) {
				administrableRightResult = module.rights.administrable
			}
		})
	}

	return administrableRightResult
}

export {getAdministrableRight, getModifyRight}